import Base from "./Base";

export default class Menu extends Base {
    create = (data) => (
        this.post('/menus', data)
    )

    search = (query) => (
        this.get(`/menus?search=${query}`)
    )

    searchByTags = (tags) => (
        this.get(`/menus?tags=${JSON.stringify(tags)}`)
    )

    find = (id) => (
        this.get(`/menus/${id}`)
    )

    listFeatured = () => (
        this.get(`/menus?featured=true&limit=4`)
    )

    addDay = (id, data) => (
        this.post(`/menus/${id}/days`, data)
    )
}



// WEBPACK FOOTER //
// ./src/services/api/Menu.js